module.exports = __webpack_public_path__ + "img/step1.ac7385f6.jpg";